import React from 'react';
import { connect } from 'react-redux';
import ReactLoading from 'react-loading';
import { Link } from 'react-router-dom';
import ReactDOM from 'react-dom';
import {
  Button
} from "react-bootstrap";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { helperFunctions as HF} from 'helper/helperFunctions';

var moment = require("moment");
var dateFormat = require('dateformat');
const queryString = require('query-string');

class FestivalFormPage extends React.Component {
	constructor(props){
		super(props);
		console.log('pricePerAdjudicator', this.props.pricePerAdjudicator);
		const parsed = queryString.extract(window.location.search);
		const referral = parsed ? parsed : null;
		const url = referral
			? (['Music-directors', 'Adjudicators'].indexOf(referral) > -1 ? `Festival/${referral}` : referral)
			: 'Festivals';
		
		this.state = {
			submitted 					: false,
			festival : {
				name  					: this.props.festivalDataFP.name      	|| '',
				venue 			    	: this.props.festivalDataFP.venue     	|| '',
				city 					: this.props.festivalDataFP.city      	|| '',
				state 					: this.props.festivalDataFP.state     	|| '',
				country 				: this.props.festivalDataFP.country   	|| '',
				start_date				: this.props.festivalDataFP.start_date ? new Date(this.props.festivalDataFP.start_date): new Date(),
				end_date 				: this.props.festivalDataFP.end_date ? new Date(this.props.festivalDataFP.end_date): new Date(),
				price_per_adjudication  : this.props.festivalDataFP.price_per_adjudication || 0,
			},
			festivalError : {
				nameError 			 		: '',
				venueError 					: '',
				cityError 					: '',
				stateError 					: '',
				countryError 				: '',
				start_dateError     		: '',
				end_dateError				: '',
				price_per_adjudicationError : '',
			},
			adjudicatorsLength : this.props.formType === 'edit' ? this.props.festivalDataFP.adjudicators.length : 0,
			showCompanyModal : false,
			adminType : this.props.adminTypeData,
			url
		};
		console.log('festival data', this.state.adjudicatorsLength);
		this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleDateChangeRaw = this.handleDateChangeRaw.bind(this);
        this.handleChangeStartDate = this.handleChangeStartDate.bind(this);
        this.handleChangeEndDate = this.handleChangeEndDate.bind(this);
        // console.log('festival', this.state.festival);
	}
	handleChangeStartDate(date){
		// console.log('date', date);
		// const { name } = e.target;
		const festivalState = {...this.state.festival};
        festivalState['start_date'] = date ? moment(date).format('YYYY-MM-DD') : null;
        this.setState({festival: festivalState});
	}

	handleChangeEndDate(date){
		// console.log('date', date);
		// const { name } = e.target;
		const festivalState = {...this.state.festival};
        festivalState['end_date'] = date ? moment(date).format('YYYY-MM-DD') : null;
        this.setState({festival: festivalState});
	}
	handleDateChangeRaw(e){
	  e.preventDefault();
	}
	handleChange(e) {
        const { name, value } = e.target;
        const festivalState = {...this.state.festival};
        festivalState[name] = value;
        this.setState({festival: festivalState});
    }


    validate(){
    	let   isError = false;
    	const errorFocus = [];
    	const errors = {
    			nameError 					: '',
				venueError 				    : '',
				cityError 					: '',
				stateError 					: '',
				countryError 				: '',
				start_dateError 			: '',
				end_dateError 				: '',
				price_per_adjudicationError : '',
    	};

    	if (this.state.festival.name.length === 0 || this.state.festival.name.trim() === '') {
      		isError = true;
      		errors.nameError = "Name of Festival is required.";
      		errorFocus.push('name');
    	}

    	if (this.state.festival.city.length === 0 || this.state.festival.city.trim() === '') {
      		isError = true;errors.cityError = "City is required.";
      		errorFocus.push('city');
    	}

    	if (this.state.festival.state.length === 0 || this.state.festival.state.trim() === '') {
      		isError = true;errors.stateError = "State is required.";
      		errorFocus.push('state');
    	}

    	if (this.state.festival.country.length === 0 || this.state.festival.country.trim() === '') {
      		isError = true;errors.countryError = "Country is required.";
      		errorFocus.push('country');
    	}

    	if (this.state.festival.start_date.length === 0 ) {
      		isError = true;errors.start_dateError = "Start date is required.";
      		errorFocus.push('start_date');
    	}

    	if (this.state.festival.end_date.length === 0 || (  dateFormat(this.state.festival.start_date, "yyyy-mm-dd") >  dateFormat(this.state.festival.end_date, "yyyy-mm-dd") ) ) {
      		isError = true;errors.end_dateError = "End date is required & End date must be greater than Start date.";
      		errorFocus.push('end_date');
    	}

    	if (this.state.festival.price_per_adjudication < 0 || !(this.state.festival.price_per_adjudication.match(/\d+/g)) ) {
      		isError = true;
      		errors.price_per_adjudicationError = "Price Per Adjudication must be greater than 0.";
      		errorFocus.push('price_per_adjudication');
    	}

    	for (var i=errorFocus.length-1; i>=0; i--) {
    		console.log('hahah',errorFocus[i]);
    		ReactDOM.findDOMNode(this.refs[errorFocus[i]]).focus();
		}

    	this.setState({festivalError: errors});
    	return isError;	
  	};

  	handleSubmit(e) {
        e.preventDefault();
        this.setState({ submitted: true }, function(){
        	if (this.state.submitted) {
	        	const err = this.validate();
		        if (!err) {
			        this.props.handleActionParent(this.state.festival);
		        } else {
		        	
		        }
	    	}
        });
    }
    componentDidUpdate(prevProps, prevState) {
    	if (  prevProps.pricePerAdjudicator !== this.props.pricePerAdjudicator && this.props.formType === 'add') {
    		

			const festivalState = {...this.state.festival};
			
			festivalState['price_per_adjudication'] = this.props.pricePerAdjudicator;

    		this.setState({ 
    			...this.state, 
    			festival:festivalState
    		});

			// this.setState({ 
    		// 	...this.state, 
    		// 	festival:
    		// 	{
    		// 		...this.state, price_per_adjudication :  this.props.pricePerAdjudicator
    		// 	} 
    		// });
    	}
    }
	render(){
		const { festival, festivalError, submitted, adminType, adjudicatorsLength } = this.state;
		const { loading, formType } = this.props;
 		return(
			<div className="col-md-12">
				<form onSubmit={this.handleSubmit} encType="multipart/form-data">
					<div className="row">
						<div className="col-md-6">
							<div className={'form-group' + (submitted && festivalError.nameError!=='' ? ' has-error' : '')}>
								<label htmlFor="name">Name of Festival</label>
								<input type="text" name="name" ref="name" className="form-control" onChange={this.handleChange} value={festival.name}  autoFocus={ festivalError.nameError!==''?true:false } readOnly={adminType ==='admin'?true:false}/>
								{
									submitted && festivalError.nameError!=='' &&
                            		<div className="help-block">{festivalError.nameError}</div>
                        		}
							</div>
						</div>
						<div className="col-md-6">
							<div className={'form-group' + (submitted && festivalError.venue!=='' ? ' has-error' : '')}>
								<label htmlFor="venue">Venue</label>
								<input type="text" name="venue" ref="venue" className="form-control" onChange={this.handleChange} value={festival.venue} autoFocus={ festivalError.venue!==''?true:false } readOnly={adminType ==='admin'?true:false}/>
								{
									submitted && festivalError.venue!=='' &&
                            		<div className="help-block">{festivalError.venue}</div>
                        		}
							</div>
						</div>
					</div>

					<div className="row">
						<div className="col-md-6">
							<div className={'form-group' + (submitted && festivalError.countryError!=='' ? ' has-error' : '')}>
								<label htmlFor="country">Country</label>
								<input type="text" name="country" ref="country" className="form-control" onChange={this.handleChange} value={festival.country} readOnly={adminType ==='admin'?true:false}/>
								{
									submitted && festivalError.countryError!=='' &&
                            		<div className="help-block">{festivalError.countryError}</div>
                        		}
							</div>
						</div>
						<div className="col-md-6">
							<div className={'form-group' + (submitted && festivalError.cityError!=='' ? ' has-error' : '')}>
								<label htmlFor="city">City</label>
								<input type="text" name="city" ref="city" className="form-control" onChange={this.handleChange} value={festival.city} readOnly={adminType ==='admin'?true:false}/>
								{
									submitted && festivalError.cityError!=='' &&
                            		<div className="help-block">{festivalError.cityError}</div>
                        		}
							</div>
						</div>
					</div>

					<div className="row">
						<div className="col-md-6">
							<div className={'form-group' + (submitted && festivalError.stateError!=='' ? ' has-error' : '')}>
								<label htmlFor="state">State</label>

								<input type="text" name="state" ref="state" className="form-control" onChange={this.handleChange} value={festival.state} readOnly={adminType ==='admin'?true:false}/>
								{
									submitted && festivalError.stateError!=='' &&
                            		<div className="help-block">{festivalError.stateError}</div>
                        		}
							</div>
						</div>
						<div className="col-md-6">
							<div className={'dateSelector form-group' + (submitted && festivalError.start_dateError!=='' ? ' has-error' : '')}>
								<label htmlFor="state">Start Date</label>
								<DatePicker ref="start_date" className="form-control calender_icon" selected={moment(festival.start_date, 'YYYY-MM-DD').toDate()} onChange={this.handleChangeStartDate} readOnly={adminType ==='admin'?true:false}/>
								{
									submitted && festivalError.start_dateError!=='' &&
									<div className="help-block">{festivalError.start_dateError}</div>
								}
							</div>
						</div>
					</div>
					<div className="row">
						<div className="col-md-6">
							<div className={'dateSelector form-group' + (submitted && festivalError.end_dateError!=='' ? ' has-error' : '')}>
								<label htmlFor="state">End Date</label>
								
								<DatePicker ref="end_date" className="form-control calender_icon" selected={moment(festival.end_date, 'YYYY-MM-DD').toDate()} onChange={this.handleChangeEndDate} readOnly={adminType ==='admin'?true:false}/>
								
								{
									submitted && festivalError.end_dateError!=='' &&
                            		<div className="help-block">{festivalError.end_dateError}</div>
                        		}
							</div>
						</div>
						<div className="col-md-6">
							<div className={'form-group' + (submitted && festivalError.price_per_adjudicationError!=='' ? ' has-error' : '')}>
								<label htmlFor="price_per_adjudication">Price per adjudication</label>
								<input type="number" step="any" name="price_per_adjudication" min="0" autoComplete="on" ref="price_per_adjudication" className="form-control dollar_icon" onChange={this.handleChange} value={festival.price_per_adjudication} readOnly={adminType === 'admin' ? false : true } />
								{
									submitted && festivalError.price_per_adjudicationError!=='' &&
                            		<div className="help-block">{festivalError.price_per_adjudicationError}</div>
                        		}
							</div>
						</div>
					</div>
					{
						formType === 'edit' &&
						<div className="row">
							<div className="col-md-6">
								<div className='form-group'>
									<label htmlFor="price_per_adjudication">Running total ({adjudicatorsLength})</label>
									<input type="number" step="any" name="price_per_adjudication_total" value={ festival.price_per_adjudication *   adjudicatorsLength } readOnly={true} className="form-control dollar_icon" />
								</div>
							</div>
						</div>
					}
					{
						adminType === 'company' &&
						<div className="row">
							<div className="col-md-12">
								<div className='form-group'>

									{
										!loading &&
										<div className="btn-toolbar">
											<Button type='submit' bsSize="large" bsStyle="info" className="outOfTableButton" >Save</Button>
											<Link to={`/Admin/${this.state.url}?restore_page=true`}  className="btn btn-info btn-lg outOfTableButton">Cancel</Link>
										</div>
									}
									
									{ loading &&
										<ReactLoading type="bars" color="#1DC7EA" height={5} width={40} />	
									}
									
								</div>
							</div>
						</div>
					}
					{
						adminType === 'admin' &&
						<div className="row">
							<div className="col-md-12">
								<div className='form-group'>
									{
										!loading &&
										<div className="btn-toolbar">
											<Button type='submit' bsSize="large" bsStyle="info" className="outOfTableButton" >Save</Button>
										</div>
									}
								</div>
							</div>
						</div>
					}
				</form>
			</div>
		);
	};
}




function mapStateToProps(state) {
    const { loading } = state.festivalReducer;
    
    return {
        loading
    };
}

const FestivalForm = connect(mapStateToProps)(FestivalFormPage);
export default FestivalForm;


// WEBPACK FOOTER //
// ./src/components/Admin/Festival/FestivalForm.jsx